<template>
  <b-modal
    id="taxi-vehicle-list-modal"
    ref="refModal"
    size="lg"
    title="Taxi Vehicle List"
    ok-only
    ok-title="Close"
  >
    <div class="d-flex justify-content-end mt-1 mb-1">
      <b-button
        size="sm"
        variant="primary"
        @click="resetVehicleData"
        v-b-modal.taxi-vehicle-modal
      >
        Add new
      </b-button>
    </div>

    <b-card
      class="vehicle-list"
      no-body
    >
      <b-card-body>
        <div
          v-for="vehicle in vehiclesArray"
          :key="vehicle.id"
          class="vehicle-item"
        >
          <b-media no-body>
            <b-media-aside>
              <b-avatar
                rounded
                size="42"
                :variant="(vehicle.isMainVehicle) ? 'light-primary' : 'light-secondary'"
              >
                <feather-icon
                  size="18"
                  icon="TruckIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="w-100">
              <div class="d-flex align-items-center mb-50">
                <h6 class="mb-0">{{ vehicle.manufacturer }}</h6>
                <div
                  v-if="vehicle.isMainVehicle"
                  class="ml-1"
                >
                  <b-badge
                    variant="light-primary"
                    class="text-capitalize"
                  >
                    Main
                  </b-badge>
                </div>
              </div>
              <small>{{ vehicle.model }}, {{ vehicle.year }}</small>
            </b-media-body>
          </b-media>

          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreHorizontalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item
              @click="editVehicle(vehicle)"
              v-b-modal.taxi-vehicle-modal
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>

          </b-dropdown>
        </div>
      </b-card-body>
    </b-card>

    <taxi-vehicle-modal
      :vehicle="vehicleData"
      @form-submitted="taxiVehicleFormSubmitted"
    />
  </b-modal>
</template>

<script>
import { BAvatar, BBadge, BButton, BCard, BCardBody, BCardText, BDropdown, BDropdownItem, BMedia, BMediaAside, BMediaBody, BModal } from "bootstrap-vue";
import { computed, ref } from "@vue/composition-api";
import router from '@/router';
import store from '@/store';
import Swal from 'sweetalert2';
import TaxiVehicleModal from '@/modules/taxi/components/TaxiVehicleModal.vue';
import useTaxiVehicle from '@/modules/taxi/composables/useTaxiVehicle';

export default {
  setup() {
    const { deleteVehicle, getTaxiVehicles } = useTaxiVehicle();

    const vehiclesArray = computed(() => store.getters['taxiVehicle/vehicles']);
    const vehicleData = ref(null);

    const editVehicle = (data) => {
      vehicleData.value = { ...data };
    };

    const removeVehicle = async (data) => {
      const { value } = await Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      });

      if (!value) return;

      await deleteVehicle(data);

      resetVehicleData();
    };

    const resetVehicleData = () => {
      vehicleData.value = {
        id: null,
        isMainVehicle: null,
        manufacturer: null,
        model: null,
        numSeats: null,
        regNum: null,
        taxiId: router.currentRoute.params.id,
        wheelchairFriendly: null,
        year: null,
      };
    };

    const taxiVehicleFormSubmitted = async (_) => {
      const taxiId = router.currentRoute.params.id;
      await getTaxiVehicles(taxiId);
    };

    return {
      // Reactive
      vehicleData,
      vehiclesArray,

      // Method
      editVehicle,
      removeVehicle,
      resetVehicleData,
      taxiVehicleFormSubmitted
    };
  },
  components: {
    BAvatar,
    BBadge,
    BButton,
    BCard,
    BCardBody,
    BCardText,
    BDropdown,
    BDropdownItem,
    BMedia,
    BMediaAside,
    BMediaBody,
    BModal,
    TaxiVehicleModal
  }
};
</script>

<style>
.vehicle-list .vehicle-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.vehicle-list .vehicle-item:not(:last-child) {
  margin-bottom: 1.2rem;
}

[dir=ltr] .vehicle-list .vehicle-item .avatar {
  margin-right: 1.2rem;
}

[dir=rtl] .vehicle-list .vehicle-item .avatar {
  margin-left: 1.2rem;
}

.vehicle-list .vehicle-item .avatar .avatar-content {
  width: 42px;
  height: 42px;
}
</style>